export default __webpack_public_path__ + "static/char-v-11-76c0914c2881729a73f84f287d52f015.webp";